import { z } from "zod";

/** Ophthalmology eye exam (per-eye refraction + VA + IOP). */

const dateStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

export const eyeExamApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	exam_date: dateStr,
	od_va_uncorrected: z.string().nullable(),
	od_va_corrected: z.string().nullable(),
	od_sphere: z.number().nullable(),
	od_cylinder: z.number().nullable(),
	od_axis: z.number().int().nullable(),
	od_add: z.number().nullable(),
	od_iop: z.number().nullable(),
	os_va_uncorrected: z.string().nullable(),
	os_va_corrected: z.string().nullable(),
	os_sphere: z.number().nullable(),
	os_cylinder: z.number().nullable(),
	os_axis: z.number().int().nullable(),
	os_add: z.number().nullable(),
	os_iop: z.number().nullable(),
	pd_mm: z.number().nullable(),
	notes: z.string().nullable(),
	recorded_by_member_id: z.string().uuid().nullable(),
	created_at: z.string().datetime(),
});
export type EyeExamApi = z.infer<typeof eyeExamApiSchema>;

const dioptre = z.coerce.number().min(-40).max(40).nullable().optional();
const axis = z.coerce.number().int().min(0).max(180).nullable().optional();
const va = z.string().max(20).nullable().optional();

export const createEyeExamInputSchema = z.object({
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().optional(),
	exam_date: dateStr,
	od_va_uncorrected: va,
	od_va_corrected: va,
	od_sphere: dioptre,
	od_cylinder: dioptre,
	od_axis: axis,
	od_add: dioptre,
	od_iop: z.coerce.number().min(0).max(80).nullable().optional(),
	os_va_uncorrected: va,
	os_va_corrected: va,
	os_sphere: dioptre,
	os_cylinder: dioptre,
	os_axis: axis,
	os_add: dioptre,
	os_iop: z.coerce.number().min(0).max(80).nullable().optional(),
	pd_mm: z.coerce.number().min(40).max(85).nullable().optional(),
	notes: z.string().max(2000).optional(),
});
export type CreateEyeExamInput = z.infer<typeof createEyeExamInputSchema>;
